<template>
  <div>
    <v-btn color="success" @click="openDialog(null)">Ajouter</v-btn>
    <v-dialog v-model="dialog" persistent min-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEditMode ? 'Modifier le template d\'email' : 'Ajouter un nouveau template d\'email' }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field 
            v-model="editedItem.title" 
            :rules="[rules.required, rules.max200]"
            label="Titre" 
          ></v-text-field>
          <v-text-field 
            v-model="editedItem.subject" 
            :rules="[rules.required, rules.max200]"
            label="Sujet de l'e-mail"
            ></v-text-field>
          <v-textarea 
            auto-grow 
            v-model="editedItem.content"
            :rules="[rules.required]"
            label="Contenu de l'e-mail"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelTemplate">Annuler</v-btn>
          <v-btn color="success" @click="saveTemplate" :disabled="!formValid">
            {{ isEditMode ? 'Mettre à jour' : 'Confirmer' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      
    <v-data-table
      :headers="headers"
      :items="$store.getters['moduleApplications/getTemplates']"
      item-key="template_id"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.subject }}</td>
        <td>{{ props.item.content }}</td>
        <td class="action-buttons">
          <v-btn color="primary" @click="openDialog(props.item)">Modifier</v-btn>
          <v-btn color="primary" @click="openDeleteConfirmation(props.item)">Supprimer</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
          Êtes-vous sûr de vouloir supprimer ce modèle d'email ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmDelete">Oui</v-btn>
          <v-btn color="primary" text @click="confirmDialog = false">Non</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
      required: value => !!value || 'Ce champ est requis',
      max200: value => (value && value.length <= 200) || 'Le texte ne peut pas dépasser 200 caractères'
      },
      confirmDialog: false, 
      deletingItem: null, 
      formValid: false,
      dialog: false,
      isEditMode: false,
      editedItem: {
        template_id: null,
        title: '',
        subject: '',
        content: ''
      },
      headers: [
        { text: 'Titre', value: 'title' },
        { text: 'Sujet', value: 'subject', sortable: false },
        { text: 'Contenu', value: 'content', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
      ],
      pagination: { sortBy: 'title', ascending: true, rowsPerPage: 25 },
    };
  },
  created() {
    this.loadEmailTemplates();
  },
  watch: {
    'editedItem.title': function (newVal, oldVal) {
      this.validateForm();
    },
    'editedItem.subject': function (newVal, oldVal) {
      this.validateForm();
    },
    'editedItem.content': function (newVal, oldVal) {
      this.validateForm();
    },
  },
  methods: {
    loadEmailTemplates() {
      console.log("loadEmailTemplates");
      this.$store.dispatch('moduleApplications/getEmailTemplates');
    },
    openDialog(template) {
      this.isEditMode = !!template;
      this.dialog = true;
      if (template) {
        this.editedItem = {
          ...template,
          title: template.title || '',
          subject: template.subject || '',
          content: template.content || '',
        };
      } else {
        this.editedItem = {
          template_id: null,
          title: '',
          subject: '',
          content: ''
        };
      this.validateForm();
      }
    },
    cancelTemplate() {
      this.dialog = false;
    },
    saveTemplate() {
      if (this.editedItem.title.length > 200 || this.editedItem.subject.length > 200) {
        return;
      }

      if (this.isEditMode) {
        this.updateTemplate();
      } else {
        this.addTemplate();
      }
      this.dialog = false;
    },
    validateForm() {
      const titleValid = this.editedItem.title.length > 0 && this.editedItem.title.length <= 200;
      const subjectValid = this.editedItem.subject.length > 0 && this.editedItem.subject.length <= 200;
      const contentValid = this.editedItem.content.length > 0;
      this.formValid = titleValid && subjectValid && contentValid;
    },
    addTemplate() {
      this.$store.dispatch('moduleApplications/addEmailTemplate', this.editedItem).then(() => {
        this.loadEmailTemplates();
      });
    },
    updateTemplate() {
      this.$store.dispatch('moduleApplications/updateEmailTemplate', this.editedItem).then(() => {
        this.loadEmailTemplates();
      });
    },
    confirmDelete() {
      if (this.deletingItem) {
        this.deleteTemplate(this.deletingItem);
        this.deletingItem = null;
        this.confirmDialog = false;
      }
    },
    deleteTemplate(item) {
      this.$store.dispatch('moduleApplications/deleteEmailTemplate', item).then(() => {
        this.loadEmailTemplates();
      });
    },
    openDeleteConfirmation(item) {
      this.deletingItem = item;
      this.confirmDialog = true;
    },
  },
};
</script>

<style>
.action-buttons {
  display: flex;
}
.action-buttons > * {
  margin-right: 8px; /* Espace entre les boutons */
}
</style>
